<template>
  <a-form :form="form" class="div taxReportForm">
    <div class="form border">
      <div class="p-3">
        <a-form-item class="mt-3 border p-2">
          <label class="form-label">Select Date Range:</label>
          <div class="row mt-1">
            <div class="col-md-8">
              <div class="mb-3">
                <a-range-picker
                  format="MM/DD/YYYY"
                  v-decorator="[
                    'dateRange',
                    {
                      initialValue: [moment().startOf('month'), moment().endOf('month')],
                      rules: [
                        {
                          type: 'array',
                          required: true,
                          message: 'Please select date range',
                        },
                      ],
                    },
                  ]"
                />
              </div>
            </div>
          </div>
        </a-form-item>
        <a-form-item class="mt-3 border p-2">
          <label class="form-label">Send to this Email Address: </label>
          <div class="row mt-1">
            <div class="col-md-8">
              <div class="mb-3">
                <a-input
                  class="emailFormField"
                  v-decorator="[
                    'email',
                    {
                      rules: [
                        {
                          type: 'email',
                          message: 'The input is not valid E-mail!',
                        },
                        {
                          required: true,
                          message: 'Please input your E-mail!',
                        },
                      ],
                    },
                  ]"
                />
              </div>
            </div>
          </div>
        </a-form-item>

        <a-form-item class="mt-3 border p-2">
          <label class="form-label">Choose a company or client:</label>
          <div class="row mt-1">
            <div class="col-md-8">
              <div class="mb-3">
                <a-select
                  mode="multiple"
                  v-decorator="[
                    'clientIds',
                    {
                      rules: [
                        {
                          required: true,
                          message: 'Please select a company or client!',
                        },
                      ],
                    },
                  ]"
                >
                  <a-select-option v-for="company in authorizedClients" :value="company.clientId" :key="company.value">
                    {{ company.clientName }}
                  </a-select-option>
                </a-select>
              </div>
            </div>
          </div>
        </a-form-item>
      </div>
    </div>
    <div class="mb-2 ms-4">
      <button class="btn btn-primary mt-2" @click="generateReport" :disabled="status === 'generating'">
        {{ status === '' ? 'Create Report' : 'Processing' }}
      </button>
    </div>
  </a-form>
</template>

<script>
export default {
  name: 'TaxReportingDatabaseForm',
  data() {
    return {
      selectCompanyOptions: [],
      selectedClients: [],
      form: this.$form.createForm(this, { name: 'taxReportForm' }),
    };
  },
  methods: {
    generateReport() {
      this.form.validateFields((errors, { email, dateRange, clientIds }) => {
        if (!errors) {
          this.$store.dispatch('taxReport/getTaxReport', {
            start_date: dateRange[0].toDate().toISOString(),
            end_date: dateRange[1].toDate().toISOString(),
            client_ids: clientIds,
            email: email,
          });
          this.form.resetFields();
          window.scrollTo(0, 0);
        }
      });
    },
  },
  computed: {
    authorizedClients() {
      return this.$store.getters['taxReport/getAuthorizedClients'];
    },
    status() {
      return this.$store.getters['taxReport/getStatus'];
    },
  },
};
</script>

<style lang="scss">
.border {
  border-radius: 5px;
}

.page-heading {
  font-size: 20px;
  font-weight: 500;
}
@mixin form-field {
  background-color: #f0f9ff !important;
  height: calc(1.5em + 1rem);
  border-radius: 0.4rem;
  border: 0 solid #ced4da !important;
  box-shadow: inset 1px 1px 3px rgb(157 193 216 / 50%);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.ant-select,
.ant-calendar-picker {
  width: 100%;
  color: #496670;
  .ant-select-selection--multiple,
  .ant-calendar-picker-input {
    @include form-field();
  }
}
.emailFormField.ant-input {
  @include form-field();
}
.ant-select-selection--multiple .ant-select-selection__rendered > ul > li.ant-select-selection__choice {
  height: calc(1em + 0.7rem);
  background-color: white;
  margin-top: 5px;
}
</style>
